<template>
  <div id="modal">
    <div class="bg-container">
      <client-only>
        <div class="carousel-container">
          <AdsCarousel
            :active-index="activeIndex"
            :pictures="pictures"
            :desktop="true"
          />
        </div>
      </client-only>
    </div>

    <div
      id="close-modal"
      @click="closeModal"
    >
      FERMER
      <img
        src="~/assets/icons/close.png"
        loading="lazy"
      >
    </div>
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  activeIndex?: number,
  pictures?: Array<any>
}>()

const emit = defineEmits(['closemodal'])

function closeModal () {
  emit('closemodal')
}
</script>

<style lang="scss" scoped>
#modal {
  position: fixed;
  inset: 0;
  z-index: 9999;
  width: 100vw;
  height: 100vh;
}

#close-modal {
  display: flex;
  align-items: center;
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 12px;
  cursor: pointer;
  font-weight: 600;
  color: white;
  padding: 10px;

  img {
    width: 13px;
    height: 13px;
    margin-left: 8px;
    filter: invert(100%) sepia(100%) saturate(0%) hue-rotate(187deg) brightness(104%) contrast(102%);
  }
}

.bg-container {
  position: absolute;
  background: rgba(0 0 0 / 80%);
  inset: 0;
  backdrop-filter: blur(6px);
  display: flex;
  align-items: center;
  justify-content: center;
}

.carousel-container {
  margin: 0;
  height: calc(100% - 100px);
  width: 100%;
}

.infos {
  margin-top: 20px;
  margin-bottom: 20px;
}

.row {
  margin-top: 10px;
  padding-left: 5%;
  padding-right: 5%;
}

#title {
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 0;
}

#subtitle {
  font-weight: normal;
  font-size: 18px;
  margin-bottom: 0;
}

.property-title,
.price {
  padding: 0;
}

.price .label {
  font-size: 14px;
  text-align: right;
  font-weight: normal;
}

.price .value {
  font-size: 24px;
  font-weight: bold;
  color: #73bfba;
  text-align: right;
}
</style>
